import {
  Box,
  Flex,
  IconButton,
  InfoOutline,
  Switch,
} from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import { useIsDesktop } from 'src/shared/hooks';
import { useEventCardState } from './context';
import { HelperText } from '../HelperText';

export type EventCardIncidentStatusProps = {
  isResolveLoading: boolean;
  onClick?: () => void;
};

export const EventCardIncidentStatus = ({
  onClick,
}: EventCardIncidentStatusProps) => {
  const { t } = useTranslation(['components.event', 'common'], {
    useSuspense: false,
  });
  const {
    event: { is_resolved },
  } = useEventCardState();
  const isDesktop = useIsDesktop();

  const label = t('incident-status.helper');

  return (
    <>
      <Flex
        borderTopWidth={1}
        py={2}
        px={{ base: 6, m: 8 }}
        align="center"
        justify="space-between"
      >
        <HelperText
          label={label}
          data-offset={
            isDesktop ? "{'top': 0, 'left': 0}" : "{'top': 0, 'left': -70}"
          }
          cursor="pointer"
        >
          <Flex align="center">
            <Box textStyle="body-normal-medium">
              {t('incident-status.title')}
            </Box>
            <IconButton
              aria-label={t('info', { ns: 'common' })!}
              height="auto"
              w="auto"
              variant="unstyled"
              icon={<InfoOutline boxSize={6} color="primary.500" />}
              _focus={{ border: 'none' }}
            />
          </Flex>
        </HelperText>

        <Flex align="center">
          <Box as="span" mr={2} textStyle="body-normal-light">
            {is_resolved
              ? t('incident-status.resolved')
              : t('incident-status.unresolved')}
          </Box>
          <Switch
            isChecked={is_resolved}
            size="lg"
            colorScheme="primary"
            onChange={onClick}
          />
        </Flex>
      </Flex>
    </>
  );
};
